module.exports = __webpack_public_path__ + "static/media/icon_solicitar_turno.f44f9f59.svg";